<template>
  <div>
    <div class="ticket-panel mt-3">
      <div
        class="text-bold mb-3 d-flex align-items-center justify-content-between"
        v-if="isCustomer"
      >
        <h4 class="mb-0 text-bold">ไฟล์แนบ</h4>
        <div>{{ list.length }}/{{ fileLimit }} รายการ</div>
      </div>
      <div class="customer-upload-panel">
        <div class="d-flex align-items-center column-gap-lg">
          <template v-if="isCustomer">
            <AddAttachmentBox
              @uploadFile="uploadFile"
              v-if="list.length != fileLimit"
            />

            <div
              class="box preview"
              v-for="(file, index) of list"
              :key="file"
              @click.prevent="openFile(file.path)"
            >
              <b-img
                v-if="isImage(file.path)"
                alt="upload image"
                :src="file.path"
                @error="handleImageSrc"
              />
              <template v-else-if="isVideo(file.path)">
                <video :src="file.path" width="300"></video>
                <div class="video-preview">
                  <font-awesome-icon icon="play"></font-awesome-icon>
                </div>
              </template>

              <div v-else class="attachment-file">
                <div>
                  <font-awesome-icon
                    icon="file-download"
                    class="attachment-icon"
                  ></font-awesome-icon>
                </div>
                <div class="attachment-name">{{ file.name }}</div>
              </div>
              <div class="delete-icon">
                <font-awesome-icon
                  @click.prevent="deleteFile(index)"
                  icon="times"
                  title="delete file attachment"
                />
              </div>
            </div>
          </template>
          <template v-else>
            <div class="action-button" @click="addAttachment" v-if="addFile">
              <font-awesome-icon
                icon="paperclip"
                title="ticket template"
                class="mr-2"
              />
              <span class="f-12"> Attachment</span>
            </div>
          </template>
          <div class="action-button" @click="showTemplate" v-if="showTemplate">
            <font-awesome-icon
              icon="border-all"
              title="ticket template"
              class="mr-2"
            />
            <span class="f-12"> Template</span>
          </div>
        </div>
      </div>
      <template v-if="list.length > 0 && !isCustomer">
        <div class="text-bold mt-3">File Attachment</div>
        <div
          class="action-button mr-2"
          v-for="(file, index) of list"
          :key="file"
          @click.prevent="openFile(file.path)"
        >
          <font-awesome-icon icon="file" title="file attachment" class="mr-2" />
          <span class="f-12"> {{ file.name }}</span>
          <font-awesome-icon
            @click.prevent="deleteFile(index)"
            icon="times"
            title="delete file attachment"
            class="ml-2"
          />
        </div>
      </template>
    </div>

    <b-modal
      centered
      v-model="isShowTemplate"
      title="Ticket Template"
      size="lg"
      hide-footer
    >
      <TemplateList
        view
        @selectTemplate="(value, flag) => onSelectTemplate(value, flag)"
        :templateId="templateId"
      />
      <b-row>
        <b-col>
          <b-button variant="custom-outline-primary" @click="hideTemplate">
            Cancel
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    <AddAttachment ref="attachment" @uploadFile="uploadFile" />
  </div>
</template>

<script>
import TemplateList from "@/components/ticket/Template.vue";
import AddAttachment from "@/components/ticket/AddAttachment.vue";
import AddAttachmentBox from "@/components/ticket/AddAttachmentBox.vue";
export default {
  components: { TemplateList, AddAttachment, AddAttachmentBox },

  props: {
    templateId: { required: false },
    addFile: {
      required: false,
      type: Boolean,
      default: false,
    },
    isCustomer: {
      required: false,
      type: Boolean,
      default: false,
    },
    showTemplate: {
      required: false,
      type: Boolean,
      default: true,
    },
    fileLimit: {
      required: false,
      default: 1,
    },
  },
  data() {
    return {
      isShowTemplate: false,
      list: [],
    };
  },
  methods: {
    showTemplate() {
      this.isShowTemplate = true;
    },
    hideTemplate() {
      this.isShowTemplate = false;
    },
    onSelectTemplate(value, flag) {
      if (flag) {
        value = { id: 0, detail: "" };
      }
      this.$emit("selectTemplate", value);
      this.hideTemplate();
    },
    addAttachment() {
      this.$refs.attachment.show();
    },
    uploadFile(file) {
      this.$refs.attachment.hide();

      this.list.push(file);
      this.$emit("onAddFileAttachment", this.list);
    },
    openFile(url) {
      window.open(url, "_blank");
    },
    deleteFile(index) {
      this.list.splice(index, 1);
      this.$emit("onAddFileAttachment", this.list);
    },
    clearFile() {
      this.list = [];
    },
    isImage(u) {
      return /\.(png|jpg|jpeg|webp|gif|heic|heif)$/i.test(u);
    },
    isVideo(u) {
      return /\.(mp4|webm|ogg|mov|avi|mkv)$/i.test(u);
    },
  },
};
</script>

<style lang="scss">
.ticket-panel {
  padding: 0.5rem;
  margin-bottom: 3rem;

  div.action-button {
    color: black;
    background-color: rgb(225 225 225);
    // background-color: white;
    padding: 0.5rem;
    display: inline-flex;
    font-size: 16px;
    cursor: pointer;
  }
}
.box {
  width: 100px;
  height: 100px;
  min-width: 100px;
  position: relative;
  border-radius: 0.4rem;
  background-color: #f1f1f1;

  &.preview {
    align-content: center;
    width: 100px;
    height: 100px;
    padding: 0.5rem;
    border-radius: 0.8rem;

    .delete-icon {
      position: absolute;
      right: 5px;
      top: 5px;
      color: white;
      background-color: gray;
      border-radius: 50%;
      font-size: 10px;
      width: 15px;
      height: 16px;
      align-content: center;
      text-align: center;
      z-index: 10;
    }
    > img {
      width: 100%;
      height: 100%;
    }
    > video {
      width: 100%;
      height: 100%;
    }
    .attachment-icon {
      font-size: 20px;
    }
    .attachment-name {
      font-size: 12px;
    }
  }
  &.add {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px dashed var(--primary-color);
    > .add-icon {
      border-radius: 50%;
      height: 24px;
      /* padding: 6px; */
      width: 24px;
      border: 1px solid var(--primary-color);
      text-align: center;
    }
  }
}

.customer-upload-panel {
  overflow: auto;
}
.attachment-file {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  > * {
    text-align: center;
  }
}
</style>
